import { render, staticRenderFns } from "./ListDiffs.vue?vue&type=template&id=2eb1e303&"
import script from "./ListDiffs.vue?vue&type=script&lang=js&"
export * from "./ListDiffs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports